import { render, staticRenderFns } from "./clerk.vue?vue&type=template&id=1935681e&scoped=true"
import script from "./clerk.vue?vue&type=script&lang=js"
export * from "./clerk.vue?vue&type=script&lang=js"
import style0 from "./clerk.vue?vue&type=style&index=0&id=1935681e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935681e",
  null
  
)

export default component.exports